import {connect} from 'react-redux';

import Minimal from '../components/template/minimal';
import AdsIframe from '../components/page/adsIframe';
import UserPostPage from '../components/page/userPostPage';

import * as AppActions from '../actions/appActions';
import * as TopSelectors from '../selectors/topLevelSelectors';

import {USER_POST} from '../constants/pageTypes';

const getContentComponent = (store) => {
  const state = store.getState();
  if (state.page.type === USER_POST) {
    return <UserPostPage store={store} />;
  }
  switch (state.page.id) {
    case 'adsIframe':
      return <AdsIframe store={store} />;
    default:
      return false;
  }
};

const mapStateToProps = (state, props) => {
  return {
    content: getContentComponent(props.store),
    country: TopSelectors.user(state).country,
    page: TopSelectors.page(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addScript: (script) => dispatch(AppActions.loadScript(script)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Minimal);
